/**
 * Tag shape geometry — clip at top (12 o'clock) on all physical silicone tags.
 * Hex uses flat-top orientation (clip on flat edge), not vertex-up.
 */

export function normalizeShape(shape) {
  const shapeMap = {
    circ: 'circle',
    circle: 'circle',
    rectangle: 'rect',
    rect: 'rect',
    triangle: 'tri',
    tri: 'tri',
    hexagon: 'hex',
    hex: 'hex',
    bone: 'bone',
  };
  return shapeMap[shape] || shape;
}

export function getTagDimensions(shape) {
  const normalized = normalizeShape(shape);
  const baseSize = 300;
  switch (normalized) {
    case 'bone':
      return { width: baseSize * 1.2, height: baseSize * 0.8 };
    case 'tri':
      return { width: baseSize * 1.2, height: baseSize * 1.2 };
    case 'rect':
      return { width: baseSize * 1.3, height: baseSize * 0.6 };
    case 'hex':
      return { width: baseSize, height: baseSize * 1.08 };
    default:
      return { width: baseSize, height: baseSize };
  }
}

/** CSS clip-path with split-ring / clip at the top edge */
export function getClipPath(shape) {
  switch (normalizeShape(shape)) {
    case 'tri':
      // Diamond: flat top (clip), point down
      return 'polygon(30% 0%, 70% 0%, 100% 42%, 50% 100%, 0% 42%)';
    case 'circle':
      return 'circle(50%)';
    case 'hex':
      // Flat top & bottom — clip centered on top flat edge
      return 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)';
    default:
      return 'none';
  }
}

export function getBorderRadius(shape) {
  const normalized = normalizeShape(shape);
  if (normalized === 'circle') return '50%';
  if (normalized === 'bone') return '999px / 40%';
  return '8px';
}

/** Padding (%) keeping text inside the laser-engravable face, below the top clip. */
export function getEngravableInsets(shape) {
  switch (normalizeShape(shape)) {
    case 'bone':
      return { top: 22, right: 24, bottom: 16, left: 24 };
    case 'rect':
      return { top: 20, right: 14, bottom: 12, left: 14 };
    case 'hex':
      return { top: 20, right: 18, bottom: 14, left: 18 };
    case 'tri':
      return { top: 18, right: 26, bottom: 20, left: 26 };
    case 'circle':
    default:
      return { top: 20, right: 16, bottom: 14, left: 16 };
  }
}

export function engravablePaddingStyle(shape) {
  const { top, right, bottom, left } = getEngravableInsets(shape);
  return {
    paddingTop: `${top}%`,
    paddingRight: `${right}%`,
    paddingBottom: `${bottom}%`,
    paddingLeft: `${left}%`,
  };
}
